// extracted by mini-css-extract-plugin
export default {"container":"usage-comparison-card_container__+ZGqr","title":"usage-comparison-card_title__wI8i2","units":"usage-comparison-card_units__CdBs-"};